import type {ReactElement} from 'react';
import React, { useRef} from 'react';
import type {BrandContent, BrandFont} from '@Components/editor-brands/editor-brands.types';
import {getBrandFontPreviewImageUrl} from '@Libraries/brands-library';
import {ClickableDiv} from '@Components/clickable-div';
import type {ContainerQueryObject} from '@Hooks/useContainerQuery';
import { useContainerQuery} from '@Hooks/useContainerQuery';
import {useAppSelector} from '@/hooks';
import styles from './brand-fonts.module.scss';

const containerQuery: ContainerQueryObject = {
  small: {
    minWidth: 0,
    maxWidth: 250,
  },
  large: {
    minWidth: 251,
  },
};

export interface BrandFontsProps {
  onFontItemClicked(e: React.MouseEvent, font: BrandFont): void;
}

function BrandFonts({...props}: BrandFontsProps): ReactElement {
  const activeBrandId: string = useAppSelector((state) => {
    return state.brands.activeBrandId ?? '';
  });
  const brandContent: Record<string, BrandContent> = useAppSelector((state) => {
    return state.brands.brandContent;
  });
  const brandFonts: Record<string, BrandFont> = useAppSelector((state) => {
    return state.brands.fonts;
  });
  const containerRef = useRef<HTMLDivElement>(null);
  const params = useContainerQuery(containerRef, containerQuery);

  const onClick = (e: React.MouseEvent, font: BrandFont): void => {
    if (!$(e.target).hasClass('disabled')) {
      props.onFontItemClicked(e, font);
    }
  };

  const getBrandFontItem = (font: BrandFont): ReactElement => {
    return (
      <ClickableDiv
        className={`font-item flex-center radius-4 ${styles.brandFontItem}`}
        onClick={(e: React.MouseEvent): void => {
          onClick(e, font);
        }}
        key={font.idbrandFont}
      >
        <img className="flex-center" src={getBrandFontPreviewImageUrl(font.idbrandFont, params.small ? '_short' : undefined)} alt={font.fontFamily} />
      </ClickableDiv>
    );
  };

  const getBrandFontContent = (): Array<ReactElement> => {
    return brandContent[activeBrandId].fonts.ids.map((id) => {
      return getBrandFontItem(brandFonts[id]);
    });
  };

  return (
    <div className={`_full-width spacing-p-t-4 ${styles.brandFonts}`} ref={containerRef}>
      {getBrandFontContent()}
    </div>
  );
}

export default BrandFonts;
